import { combineReducers } from 'redux';
import user from './user'
import school from './school'
import report from './report'
import attendance from './attendance'
import behavior from './behavior'
import feedback from './feedback'
import fee from './fee'
import cbt from './cbt'
import lessonplan from './lessonplan'
import note from './note'
import subject from './subject'
import studentreport from './studentreport'

export default combineReducers({
    userReducer:user,
    schoolReducer:school,
    reportReducer:report,
    attendanceReducer:attendance,
    behaviorReducer:behavior,
    feedbackReducer:feedback,
    feeReducer:fee,
    cbtReducer:cbt,
    lessonplanReducer:lessonplan,
    noteReducer:note,
    subjectReducer:subject,
    studentreportReducer:studentreport
})